import type { SxProps, Theme } from '@mui/material'

interface DiffStatsOptions {
  readonly italic?: boolean
  readonly fontSize?: string
}

export const diffStatsAddedSx = (theme: Theme, options: DiffStatsOptions = {}): SxProps<Theme> => ({
  color: theme.palette.success.main,
  fontWeight: 500,
  ...(options.italic && { fontStyle: 'italic' }),
  ...(options.fontSize && { fontSize: options.fontSize }),
})

export const diffStatsRemovedSx = (
  theme: Theme,
  options: DiffStatsOptions = {},
): SxProps<Theme> => ({
  color: theme.palette.error.main,
  fontWeight: 500,
  ...(options.italic && { fontStyle: 'italic' }),
  ...(options.fontSize && { fontSize: options.fontSize }),
})
